// extracted by mini-css-extract-plugin
export default {"hideSubhead":"about-salon-modal_hideSubhead__uCucc","addresessCount":"about-salon-modal_addresessCount__neF9+","addresessHeader":"about-salon-modal_addresessHeader__MBmSL"};